// import { Navigation, Pagination } from "swiper/modules";
import "slick-carousel";
import $ from "jquery";
const mediaSlider = () => {
  const init = () => {
    slider();
  };

  const slider = (sliderId) => {
    const el = {
      swiper: `#${sliderId}`,
      dots: `#${sliderId}-dots`,
      nextArrow: `#${sliderId}-next`,
      prevArrow: `#${sliderId}-prev`,
    };

    if ($(el.swiper).length === 0) return;

    // * Slick Js
    $(el.swiper).slick({
      dots: true,
      appendDots: $(el.dots),
      infinite: true,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      nextArrow: $(el.nextArrow),
      prevArrow: $(el.prevArrow),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  };

  // Initialize sliders
  $(".mi-gallery-slider").each(function () {
    const sliderId = $(this).attr("id");
    slider(sliderId);
  });

  init();
};

try {
  mediaSlider();
} catch (e) {
  console.error("Gallery Slider : ", e);
}
